import React, { } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from "react-router-dom";
import { Button } from "reactstrap";
import "./index.scss";

const UploadFileMessage = ({setShowMessage}) => {
	const history = useHistory();
	const handleQueue = () => {
		history.push('/uploading-file')
	}
	return (
		<>
			<div className="upload-file-msg flex-fill d-flex align-items-center justify-content-center  position-relative">
				<div className="inner">
					<label>The file is taking more then expected time to upload.</label>
					<Button color="link" className="btn-outline-danger" onClick={handleQueue}>
						View all Queued Files
					</Button>
				</div>

				<Button color="link" className="position-absolute close-btn" onClick={() => setShowMessage(false)}>
					<FontAwesomeIcon icon={faTimes} />
				</Button>
			</div>
		</>
	)
};
export default UploadFileMessage;